import {useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import axios from "axios";
import {restUrl} from "../../../../apiUrl";
import {MetaDataTable} from "../../Grading/component/MetaDataTable";

export const FeedbackBase = ({admin = false}) => {
    const { state } = useLocation()

    const [metaData, setMetaData] = useState({})
    const [list, setList] = useState([])

    useEffect(() => {
        init()
    }, []);

    const init = async () => {
        const {data} = await axios.get(`${restUrl}/activity_test_problem_view_feedback?test_id=eq.${state.testId}&app_id=eq.${state.appId}`)
        setList(data)
        const res = await axios.get(`${restUrl}/list_test_grade?test_id=eq.${state.testId}&app_id=eq.${state.appId}`)
        setMetaData(res.data)
    }

    const changeFeedback = (index, e)=>{
        const d = [...list]
        d[index].feedback = e.target.value
        setList(d)
    }

    const navigate = useNavigate()
    const submitFeedback = async () => {
        const c = window.confirm("저장하시겠습니까?")
        if (!c) return
        for (const item of list) {
            await axios.patch(`${restUrl}/activity_test_problem_response_feedback?id=eq.${item.feedback_id}`,{feedback: item.feedback})
        }
        navigate(-1)
    }

    return (<>
        <MetaDataTable data={metaData}/>
        <table>
            <thead><tr>
                <th>번호</th>
                <th>문제</th>
                <th>보기</th>
                <th>정답</th>
                <th>제출한 답</th>
                <th>배점</th>
                <th>점수</th>
                <th>피드백</th>
            </tr></thead>
            <tbody>
            {list.length > 0 && list.map((item, index) => <tr key={index}>
                <td>{index+1}</td>
                <td>{item.problem}</td>
                <td>{item.selection}</td>
                <td>{item.answer}</td>
                <td>{item.response}</td>
                <td>{item.score}</td>
                <td>{item.grade}</td>
                {!admin ? item.feedback: <td>
                    <input className='inputBorder inputTextAreaMargin' value={item.feedback}
                        onChange={event => changeFeedback(index, event)}/>
                    </td>}
            </tr>)}
            </tbody>
        </table>
        <button onClick={submitFeedback}>저장</button>
    </>)
}